import "./user-new.scss";
import { SHA256 } from "crypto-js";
import { useState, useEffect, FormEvent, useContext } from "react";
import { Button, Form } from "react-bootstrap";
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

import { ITableRowData, IColumn } from "../../../shared/components/normal-table/normal-table";
import Spinner from "../../../shared/components/spinner/spinner";
import { roleAdmin } from "../../../shared/constants/user-roles";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { postSingleNonTable } from "../../../shared/utils/api";
import { RenderFields } from "../../../shared/utils/render-fields";
import { activeOptions } from "../../../shared/utils/static-values";
import { useBack } from "../../../shared/utils/use-back";
import { validateLoadingStatusNew } from "../../../shared/utils/utils";
import { createUUID } from "../../../shared/utils/utils";


const fields: IColumn[] = [
  {
    key: "name",
    displayName: "First Name",
    dataType: {
      type: "text",
    },
  },
  {
    key: "last_name",
    displayName: "Last Name",
    dataType: {
      type: "text",
    },
  },
  {
    key: "password",
    displayName: "Password",
    dataType: {
      type: "text",
    },
    subType: "password",
  },
  {
    key: "email",
    displayName: "Email Address",
    dataType: {
      type: "text",
    },
  },
  {
    key: "active_status",
    displayName: "Active",
    dataType: {
      type: "enumeration",
      values: activeOptions,
    },
  },
  {
    key: "admin",
    displayName: "Technical admin",
    dataType: {
      type: "enumeration",
      values: activeOptions,
    },
    noEmptyDefault: true
  },
];

const UserNew = () => {
  const [validated, setValidated] = useState(false);
  const [data, setData] = useState<ITableRowData>({id: "", groups: [], roles: [] });
  const [unblockInput, setUnblockInput] = useState(false);
  const authCtx = useContext(AuthContext);
  const { sendRequest: postSingleRequest, status: allStatusPost, error: errorPost } = useHttp(postSingleNonTable, false, authCtx.token);
  const { handleBack } = useBack();
  const navigate = useNavigate();

  useEffect(() => {
    const rolesArray = authCtx.selectedTenant.roles;
    if (rolesArray.indexOf(roleAdmin) !== -1 || authCtx.systemAdmin) {
      setUnblockInput(true);
    }
  }, [authCtx.selectedTenant, authCtx.systemAdmin]);

  useEffect(() => {
    if (allStatusPost === "completed" && !errorPost) {
      navigate("/users");
    }
  }, [allStatusPost ]);

  const handleOnChange = (targetVal: string | boolean | null, inputKey: string) => {
    setData((prevState) => ({ ...prevState, [inputKey]: targetVal }));
  };

  const getData = (url: string) => {
    console.log(url);
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const createdId = createUUID();
    const hashedPassword = SHA256(data.password).toString();
    if (form.checkValidity()) {
      unblockInput && postSingleRequest(`user/${createdId}`, {id:createdId ,name: data.name, last_name: data.last_name, password: hashedPassword, email:data.email, active_status: data.active_status, admin: data.admin});
    }
    setValidated(true);
  };

  const renderFields = () => {
    if (fields.length !== 0) {
      return (
        <RenderFields
          mode="aside"
          fields={fields}
          data={data}
          getData={getData}
          handleOnChange={handleOnChange}
        />
      );
    }
  };

  return (
    <div className="userNew">
      <div onClick={() => handleBack()} className="listPage-nav-btn">
        <BsArrowLeft />
      </div>
      <div className="userNew-header">
        <h1 className="mt-2 mb-3">
          Create a User
        </h1>
      </div>
      <div className="userNew-form">
        {validateLoadingStatusNew([allStatusPost]) && <Spinner />}
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          {renderFields()}
          <div className="userNew-buttonsGroup">
            <Button disabled={!unblockInput} className="userNew-save" type="submit" variant="primary">
              Save
            </Button>
          </div>          
        </Form>
      </div>
    </div>
  );
};

export default UserNew;
